

//list2====
$('.list2 .item').hover(function () {
  $(this).addClass('focus')
}, function () {
  $(this).removeClass('focus')

})
  
//list4===
setTimeout(() => {

  // 监听所有 class 为 'top' 的 div 元素的点击事件
    $('.list4 .swiper-slide').on('click', function(event) {
        // 1. 查找当前被点击的 .top 元素内部的 a 标签
        // 假设每个 .top 内部只有一个主要的跳转 a 标签
        var $anchor = $(this).find('a:first'); 
        
        // 2. 检查点击事件是否直接发生在 a 标签上
        // 如果是直接点击 a 标签，我们让 a 标签的默认行为执行，不做额外处理。
        // `event.target` 是实际被点击的元素。
        if ($(event.target).closest('a').length) {
            return; 
        }

        // 3. 检查是否找到了 a 标签并且它有 href 属性
        if ($anchor.length && $anchor.attr('href')) {
            // 4. 获取 a 标签的 URL
            var url = $anchor.attr('href');

            // 5. 阻止事件冒泡到父级元素 (虽然通常不需要，但这是一个好习惯)
            event.preventDefault(); 
            event.stopPropagation();

            // 6. 执行页面跳转
            // 如果您希望在新窗口打开，可以使用 window.open(url, '_blank');
            window.location.href = url;
        }
    });
  
  var swiper = new Swiper('.list4 .swiper-container', {
  pagination: '.swiper-pagination',
  slidesPerView: 4,
  
  paginationClickable: true,
  spaceBetween: 20,
  prevButton: '.swiper-button-prev',
  nextButton: '.swiper-button-next',
});
$('.list4 .swiper-button-prev').mouseover(function () {
  $(this).addClass('hv')
})
$('.list4 .swiper-button-prev').mouseout(function () {
  $(this).removeClass('hv')
})
$('.list4 .swiper-button-next').mouseover(function () {
  $(this).addClass('hv')
})
$('.list4 .swiper-button-next').mouseout(function () {
  $(this).removeClass('hv')
})
console.log('=轮播图个数==',$('#shopify-section-template--19609589448931__list_v1_part4_C6FWjj  .list4 .pc .swiper-slide').length ,$('#shopify-section-template--19609589448931__list_v1_part4_wVLQqw  .list4 .pc .swiper-slide').length)
if($('#shopify-section-template--19609589448931__list_v1_part4_C6FWjj  .list4 .pc .swiper-slide').length <=4){
  $('#shopify-section-template--19609589448931__list_v1_part4_C6FWjj  .list4 .pc .swiper-pagination').css('display','none')

}
if($('#shopify-section-template--19609589448931__list_v1_part4_wVLQqw  .list4 .pc .swiper-slide').length <=4){
  $('#shopify-section-template--19609589448931__list_v1_part4_wVLQqw  .list4 .pc .swiper-pagination').css('display','none')

}
for(let i =0;i<$('.list4 .swiper-slide').length ;i++){
  
  if(!$('.list4 .swiper-slide').eq(i).find('.sp').html()){
    // console.log('====1===',$(this).find('.bor'))
   $('.list4 .swiper-slide').eq(i).find('.bor').hide();
   $('.list4 .swiper-slide').eq(i).removeClass('top');
  }else{
    console.log('====2===')

  }
}
$('.list4 .swiper-slide').hover(function () {
  console.log('===',$(this).find('.sp').html())
      $(this).addClass('Bo')

 
}, function () {
  $(this).removeClass('Bo')

})

}, 300);

//list5-==
$('.list5 .box').hover(function () {
  $(this).addClass('hover')
}, function () {
  $(this).removeClass('hover')

})